export default "/images/Sealants.webp?ab8d65bd70d00584f87356405f2c2679";